import { ThemeType } from '../contexts/ThemeContext';

export interface ThemeColors {
  // Backgrounds
  primaryBg: string;
  secondaryBg: string;
  cardBg: string;
  headerBg: string;
  
  // Text colors
  primaryText: string;
  secondaryText: string;
  accentText: string;
  
  // Gradients
  heroGradient: string;
  ctaGradient: string;
  featureGradient: string;
  benefitsGradient: string;
  
  // Buttons
  primaryButton: string;
  secondaryButton: string;
  whatsappButton: string;
  
  // Borders and shadows
  borderColor: string;
  shadowColor: string;
  cardShadow: string;
}

export const getThemeColors = (theme: ThemeType, isDark: boolean, isHighContrast: boolean): ThemeColors => {
  if (isHighContrast) {
    return {
      // Alto Contraste - Cores vibrantes e contrastantes
      primaryBg: '#000000',
      secondaryBg: '#ffffff',
      cardBg: '#ffffff',
      headerBg: 'rgba(255, 255, 255, 0.98)',
      
      primaryText: '#ffffff',
      secondaryText: '#000000',
      accentText: '#ffff00',
      
      heroGradient: 'linear-gradient(135deg, #000000 0%, #ff0000 100%)',
      ctaGradient: 'linear-gradient(135deg, #ffff00 0%, #ff0000 100%)',
      featureGradient: 'linear-gradient(135deg, #0000ff 0%, #ff00ff 100%)',
      benefitsGradient: 'linear-gradient(135deg, #00ff00 0%, #0000ff 100%)',
      
      primaryButton: '#ffff00',
      secondaryButton: '#0000ff',
      whatsappButton: '#00ff00',
      
      borderColor: '#ffff00',
      shadowColor: 'rgba(255, 255, 0, 0.5)',
      cardShadow: '0 10px 40px rgba(255, 255, 0, 0.3)',
    };
  }

  if (isDark) {
    return {
      // Modo Escuro - Tons escuros e elegantes
      primaryBg: '#0f172a',
      secondaryBg: '#1e293b',
      cardBg: '#334155',
      headerBg: 'rgba(30, 41, 59, 0.95)',
      
      primaryText: '#f8fafc',
      secondaryText: '#cbd5e1',
      accentText: '#60a5fa',
      
      heroGradient: 'linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)',
      ctaGradient: 'linear-gradient(135deg, #dc2626 0%, #ea580c 100%)',
      featureGradient: 'linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)',
      benefitsGradient: 'linear-gradient(135deg, #ec4899 0%, #f97316 100%)',
      
      primaryButton: '#3b82f6',
      secondaryButton: '#6366f1',
      whatsappButton: '#10b981',
      
      borderColor: '#475569',
      shadowColor: 'rgba(0, 0, 0, 0.3)',
      cardShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
    };
  }

  // Modo Claro - Cores vibrantes e modernas
  return {
    primaryBg: '#f8fafc',
    secondaryBg: '#ffffff',
    cardBg: '#ffffff',
    headerBg: 'rgba(255, 255, 255, 0.95)',
    
    primaryText: '#1e293b',
    secondaryText: '#64748b',
    accentText: '#3b82f6',
    
    heroGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    ctaGradient: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
    featureGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    benefitsGradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    
    primaryButton: '#3b82f6',
    secondaryButton: '#6366f1',
    whatsappButton: '#25d366',
    
    borderColor: '#e2e8f0',
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    cardShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
  };
}; 